import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import { Controller } from "react-hook-form";
import ValidationErrorText from "./ValidationErrorText";
import { useTranslation } from "react-i18next";

const CustomInput = forwardRef(
  ({ value, onClick, disabled, placeholderText, errors }, ref) => (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      readOnly
      disabled={disabled}
      placeholder={placeholderText}
      className="form-control"
    />
  )
);

CustomInput.displayName = "CustomInput";

const DatePickerDefault = ({
  control,
  name,
  rules,
  placeholder,
  icon: Icon,
  disabled,
  minDate,
  maxDate,
  yearDropdown,
  monthDropdown,
  onDateChange=null,
  border,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <DatepickerWrapper border={border && border} {...rest}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <DatePicker
              selected={value}
              onChange={(e) => {
                onChange(e)
                if(onDateChange) onDateChange(name, e);
              }}
              dateFormat="yyyy/MM/dd"
              showMonthDropdown={monthDropdown}
              showYearDropdown={yearDropdown}
              dropdownMode="select"
              disabled={disabled}
              customInput={
                <CustomInput
                  disabled={disabled}
                  placeholderText={placeholder}
                />
              }
              minDate={minDate}
              maxDate={maxDate}
              {...(Icon && { showIcon: true, icon: <Icon /> })}
            />
            {error?.type === "required" && (
              <ValidationErrorText text={t("fieldRequired")} />
            )}
          </>
        )}
      />
    </DatepickerWrapper>
  );
};

const DatepickerWrapper = styled.div`
  width: 100%;
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-wrapper .form-control {
    background-color: ${({ bg }) => (bg ? bg : "var(--white)")};
    border: ${({ border }) => (border ? "none": "1px solid var(--borderLight)")};
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    color: var(--text);
    font-size: 14px;
    &::placeholder {
      color: var(--text2);
    }
  }

  .react-datepicker__input-container {
    display: flex;
    align-items: center;
  }

  .react-datepicker__calendar-icon {
    width: 18px;
    height: 19px;
    padding-top: 5px;
  }

  .react-datepicker__view-calendar-icon input {
    padding: 6px 10px 5px 33px;
    body.rtl & {
      padding: 6px 33px 5px 10px;
    }
  }

  .form-control:focus {
    box-shadow: none;
    outline: none;
  }
`;

export default DatePickerDefault;
